export type Estq_env = {
    baseURL: string;
    recaptcha_site_key: string;
    header_logo_link_url: string;
    draft_acceess_url: string;
};

export const env_user: Estq_env = {
    baseURL: process.env.REACT_APP_BASE_URL,
    recaptcha_site_key: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
    header_logo_link_url: process.env.REACT_APP_HEADER_LOGO_LINK_URL,
    draft_acceess_url: process.env.REACT_APP_DRAFT_ACCESS_URL,
};
